import type React from 'react'

import { prefersReducedMotion } from '../../utilities/misc/prefersReducedMotion'

export const hasScrollbar = (ref: React.MutableRefObject<HTMLElement | null>) => {
  if (!ref || ref.current === null) {
    return false
  }

  try {
    return ref.current.scrollWidth > ref.current.clientWidth
  } catch {
    return false
  }
}

export const getScrollPosition = ({ scroller, x, width }: GetScrollPositionArgs) => {
  const defaultResponse = { atStart: true, atEnd: false, inMiddle: false }
  if (!scroller || scroller.current === null) {
    return defaultResponse
  }

  try {
    const atStart = x === 0
    const atEnd = !atStart && x + Math.round(width) === scroller.current.scrollWidth
    return { atStart: atStart, atEnd: atEnd, inMiddle: !atStart && !atEnd }
  } catch {
    return defaultResponse
  }
}

export const setScroll = ({
  node,
  position,
  behaviour = prefersReducedMotion() ? 'auto' : 'smooth',
}: GetScrollArgs) => node && node.scrollTo?.({ top: 0, behavior: behaviour, left: position })

///////// IMPLEMENTATION /////////

type GetScrollArgs = {
  node: HTMLElement
  position: number
  behaviour?: ScrollBehavior
}

type GetScrollPositionArgs = {
  scroller: React.MutableRefObject<HTMLElement | null>
  x: number
  width: number
}
